// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WjQ4","left":"styles_left__1j-Dg"};